// extracted by mini-css-extract-plugin
export default {"inputLabel":"styles_inputLabel__zM5Ss","inputHover":"styles_inputHover__Q61ps"};